export const CARD_WIDTH = 350
export const MOBILE_WIDTH_BREAKPOINT = 768 // should match: $utk-search-breakpoints, small
export const GAP = 24 // 2x the padding for each card which is 12px
export const ESTIMATED_ASSET_ROW_HEIGHT = 408
export const CARD_HEIGHT = 384
